import { DateUtils } from 'src/app/shared/utils/date/date.utils';
import { Component, computed, inject, input, output } from '@angular/core';
import { OrderStatusLabels } from '@config/labels/order.labels';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-resume-order-atom',
  templateUrl: './resume-order-atom.component.html',
  standalone: false,
})
export class ResumeOrderAtomComponent {
  private readonly translateService = inject(TranslateService);

  readonly title = input.required<string>();
  readonly description = input('');
  readonly shopName = input.required<string>();
  readonly orderStatus = input.required<keyof typeof OrderStatusLabels>();
  readonly orderDate = input<Date | null>(null);
  readonly orderAmount = input.required<number>();
  readonly actionName = input('');
  readonly nbProducts = input.required<number>();

  readonly action = output<void>();
  readonly cardClick = output<void>();

  readonly orderStatusLabels = OrderStatusLabels;

  readonly order_date = computed(() => {
    const date = this.orderDate();
    if (!date) {
      return '';
    }
    return DateUtils.formatLocalizedDate(date, this.translateService.instant('date.short-format'));
  });
}
